import React, { useEffect, useRef, useState } from 'react';
import { Selector } from 'src/components';
import ArrowRightIcon from 'src/components/Icons/arrowRight';
import { isNullOrEmptyArray } from 'src/util/arrays';
import * as Ui from './styles';

export default function GraphFilter({
  // Pergunta principal
  mainQuestion,
  // Array perguntas secundárias
  filterData = [],
  // Evento de propagação acionado ao selecionar uma pergunta e uma alternativa
  onChange,
  /* 
    * Propriedade para identificar quando os dados do gráfico estão sendo carregados
    * Ao passar para o styled é utilizado "loading ? 1 : 0" devido ao warning no console
  */
  loading,
  // Propriedade para identificar quando existem configurações criadas
  hasConfigs = []
}) {
  // states
  const [secondaryQuestions, setSecundaryQuestions] = useState([]);
  const [alternatives, setAlternatives] = useState([]);
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(0);
  const [selectedAlternativeIndex, setSelectedAlternativeIndex] = useState(0);

  // refs
  const questionSelectorRef = useRef(null);
  const alternativeSelectorRef = useRef(null);

  function parseToSelector(data) {
    return data.map(({ enunciado: label, id: value }) => ({ label, value }));
  }

  useEffect(() => {
    if (!isNullOrEmptyArray(filterData)) {
      const questions = parseToSelector(filterData);
      setSecundaryQuestions(questions);
      
      const alternatives = parseToSelector(filterData[0].alternativas);
      setAlternatives(alternatives);

      setSelectedQuestionIndex(0);
      setSelectedAlternativeIndex(0);
    }
  }, [filterData]);

  useEffect(() => {
    if (!isNullOrEmptyArray(secondaryQuestions) && !isNullOrEmptyArray(alternatives) && typeof selectedAlternativeIndex === 'number') {
      if (onChange) {
        onChange({ questionId: secondaryQuestions[selectedQuestionIndex].value, alternativeId: alternatives[selectedAlternativeIndex].value });
      }
    }
  }, [secondaryQuestions, alternatives, selectedAlternativeIndex, selectedQuestionIndex]);

  function handleSelect([item]){
    const findedDataItemIndex = filterData.findIndex(({ id: questionId }) => questionId === item.value);

    if (findedDataItemIndex !== -1) {
      const findedDataItem = filterData[findedDataItemIndex];
      const alternatives = parseToSelector(findedDataItem.alternativas);
      setAlternatives(alternatives);
      setSelectedQuestionIndex(findedDataItemIndex);
      setSelectedAlternativeIndex(0);
    }
  }

  function handleOnSelectAlternative([item]) {
    const findedDataItemIndex = alternatives.findIndex(({ value }) => value === item.value);

    if (findedDataItemIndex !== -1) {
      setSelectedAlternativeIndex(findedDataItemIndex);
    }
  }

  
  return (
    <Ui.Container>
      <Ui.Wrapper loading={loading ? 1 : 0} hasConfigs={hasConfigs}>
        <Ui.Text>Pergunta Principal</Ui.Text>
        <Ui.MainQuestionWrapper>
          <Ui.MainQuestion>{mainQuestion}</Ui.MainQuestion>
          <ArrowRightIcon />
        </Ui.MainQuestionWrapper>
      </Ui.Wrapper>
    
      <Ui.Wrapper loading={loading ? 1 : 0} hasConfigs={hasConfigs}>
        <Ui.Text>Perguntra Secundária</Ui.Text>
        <Selector
          ref={questionSelectorRef}
          data={secondaryQuestions}
          className={'evolutiveSelectFilter'}
          onChange={handleSelect}
          placeholder={'Selecione uma pergunta secundária'}
          initialSelectedIndexes={[selectedQuestionIndex]}
        />
      </Ui.Wrapper>

      <Ui.Wrapper loading={loading ? 1 : 0} hasConfigs={hasConfigs}>
        <Ui.Text>Alternativa</Ui.Text>
        <Selector
          ref={alternativeSelectorRef}
          data={alternatives}
          className={'evolutiveSelectFilter'}
          placeholder={'Selecione uma alternativa'}
          onChange={handleOnSelectAlternative}
          initialSelectedIndexes={[selectedAlternativeIndex]}
        />
      </Ui.Wrapper>
    </Ui.Container>
  );
}